import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController, MenuController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO} from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { UtilsProvider } from '../../providers/utils/utils'
import { CargosPage } from '../cargos/cargos';
import { UsuariosPage } from '../usuarios/usuarios';
import { ClientesPage } from '../clientes/clientes';
import { ProveedoresPage } from '../proveedores/proveedores';
import { CompaniasPage } from '../companias/companias';
import { CompaniasUsuariosPage } from '../companias-usuarios/companias-usuarios';
import { PermisosPage } from '../permisos/permisos';
import { PermisosOpcionesUsuariosPage } from '../permisos-opciones-usuarios/permisos-opciones-usuarios';
import { GruposProductosPage } from '../gruposProductos/gruposProductos';
import { ProductosPage } from '../productos/productos';
import { ProductosElaboradosPage } from '../productos-elaborados/productos-elaborados';
import { ProductosElaboradosContenidoPage } from '../productos-elaborados-contenido/productos-elaborados-contenido';
import { ProductosPorGruposDragPage } from '../productos-por-grupos-drag/productos-por-grupos-drag';
import { ConceptosEgresosPage } from '../conceptos-egresos/conceptos-egresos';
import { EgresosIngresosDiariosPage } from '../egresos-ingresos-diarios/egresos-ingresos-diarios';
import { ProveedoresCargarStockPage } from '../proveedores-cargar-stock/proveedores-cargar-stock';
import { MesasPage } from '../mesas/mesas';
import { MeseromeseroPage } from '../meseromesero/meseromesero';
import { ComandasPage } from '../comandas/comandas';
import { SalonPage } from '../salon/salon';
import { CajaPage } from '../caja/caja';
import { CuentasPorCobrarPage } from '../cuentas-por-cobrar/cuentas-por-cobrar';
import { CuadreCajaDiarioValoresPorDenominacionPage } from '../cuadre-caja-diario-valores-por-denominacion/cuadre-caja-diario-valores-por-denominacion';
import { DesperdiciosPage } from '../desperdicios/desperdicios';
import { EntidadesGeneralesPage } from '../entidades-generales/entidades-generales';
import { CrearCarruselImagePage } from '../crear-carrusel-image/crear-carrusel-image';
import { CarruselImagePage } from '../carrusel-image/carrusel-image';
import { ImpresoraPage } from '../impresora/impresora';
import { InformeGestionesPage } from '../informe-gestiones/informe-gestiones';
import { InformeCuentasPorCobrarPage } from '../informe-cuentas-por-cobrar/informe-cuentas-por-cobrar';
import { InformeVentasDevueltasPage } from '../informe-ventas-devueltas/informe-ventas-devueltas';
import { InformeReimprimirReciboCajaPage } from '../informe-reimprimir-recibo-caja/informe-reimprimir-recibo-caja';
import { InformeIngresoMercanciaPorDiaPage } from '../informe-ingreso-mercancia-por-dia/informe-ingreso-mercancia-por-dia';
import { InformeExistenciasProductosActualesPage } from '../informe-existencias-productos-actuales/informe-existencias-productos-actuales';
import { InformeCuadresDiariosPage } from '../informe-cuadres-diarios/informe-cuadres-diarios';
import { InformeDesperdiciosPorDiaPage } from '../informe-desperdicios-por-dia/informe-desperdicios-por-dia';
import { InformeProductosVendidosPorDiasPage } from '../informe-productos-vendidos-por-dias/informe-productos-vendidos-por-dias';
import { InformeCantidadesDescontadasInventarioPorDiaPage } from '../informe-cantidades-descontadas-inventario-por-dia/informe-cantidades-descontadas-inventario-por-dia';
import { InformeBalanceNegocioPage } from '../informe-balance-negocio/informe-balance-negocio';
import { VentasDiariasPorCostosPage } from '../ventas-diarias-por-costos/ventas-diarias-por-costos';
import { DevolverAbonosPage } from '../devolver-abonos/devolver-abonos';
import { DevolverVentasPage } from '../devolver-ventas/devolver-ventas';
import { ParametrosCajaPage } from '../parametros-caja/parametros-caja';
import { ParametrosGeneralesPage } from '../parametros-generales/parametros-generales';
import { ReservasPage } from '../reservas/reservas';
import { GruposReservasPage } from '../grupos-reservas/grupos-reservas';
import { TiposReservasPage } from '../tipos-reservas/tipos-reservas';
import { GruposReservasPorProductoPage } from '../grupos-reservas-por-producto/grupos-reservas-por-producto';
import { ReservasTiposPorValorPage } from '../reservas-tipos-por-valor/reservas-tipos-por-valor';
import { ReservasSinAsignarPage } from '../reservas-sin-asignar/reservas-sin-asignar';
import { InformeCambiosMaestroComponent } from '../../components/informe-cambios-maestro/informe-cambios-maestro';
import { ProveedoraPorProductoComponent } from '../../components/proveedora-por-producto/proveedora-por-producto';
import { ProveedoraPorProductoEquivalenciaComponent } from '../../components/proveedora-por-producto-equivalencia/proveedora-por-producto-equivalencia';
import { EstadosParqueaderoComponent } from '../../components/estados-parqueadero/estados-parqueadero';
import { EstadosParqueaderosPorValorComponent } from '../../components/estados-parqueaderos-por-valor/estados-parqueaderos-por-valor';
import { ParqueaderosComponent } from '../../components/parqueaderos/parqueaderos';
import { ReservasGrupalesComponent } from '../../components/reservas-grupales/reservas-grupales';
import { ProductosRapidosComponent } from '../../components/productos-rapidos/productos-rapidos';
import { InformesMovimientosElectronicosComponent } from '../../components/informes-movimientos-electronicos/informes-movimientos-electronicos';
import { PosElectronicoComponent } from '../../components/pos-electronico/pos-electronico';
import { DianFacturaElectronicaPage } from '../dian-factura-electronica/dian-factura-electronica';
import { PoselectronicoPage } from '../poselectronico/poselectronico';
import { InteresesCreditosComponent } from '../intereses-creditos/intereses-creditos';
import { ProductosTransladosComponent } from '../../components/productos-translados/productos-translados';
import { UsuarioPedidoSalonComponent } from '../../components/usuariopedidosalon/usuariopedidosalon';
import { CuentasPorCobrarCreditosPage } from '../cuentas-por-cobrar-creditos/cuentas-por-cobrar-creditos';
import { inventarioPage } from '../inventario/inventario';
import { GraficasPage } from '../graficas/graficas';
import { MovimientosElectronicosComponent } from '../../components/movimientos-electronicos/movimientos-electronicos';

@IonicPage()
@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html',
  providers: [ AuthService ]
})
export class MenuPage {
  datosPagina:any[] = []
  datosPaginaReal:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  constructor(public navCtrl: NavController, public navParams: NavParams,
             public alertControllers:AlertController,
             public storages:Storage,
             public auth: AuthService,
             public utils: UtilsProvider,
             public servicioCompania:CompaniasProvider,
             public menuControllers:MenuController) {
              if(!MODO_DESCONECTADO){
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })

                this.datosPagina = [
                    { "titulo":"Personal","id":1},
                    { "titulo":"Negocio","id":2},
                    { "titulo":"Productos","id":3},
                    { "titulo":"Gestión Financiera y de Inventarios","id":4},
                    { "titulo":"Operaciones de Salón y Finanzas","id":5},
                    { "titulo":"Reservas","id":6},
                    { "titulo":"Utilidades","id":7},
                    { "titulo":"Informe ventas","id":8},
                    { "titulo":"Informe balance","id":9},
                    { "titulo":"Informe productos","id":10},
                    { "titulo":"Informe gestión turnos","id":11},
                    { "titulo":"Seguridad","id":12},
                    { "titulo":"Devoluciones","id":13},
                    { "titulo":"Proveedora","id":14},
                    { "titulo":"Parqueadero","id":15},
                    { "titulo":"Dian","id":16}
                ]

                this.datosPaginaReal = [
                 {  "titulo":"Cargos","id":1,"nombre":"CargosPage","ruta":"CargosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"person"},
                 {  "titulo":"Usuarios","id":1,"nombre":"UsuariosPage","ruta":"UsuariosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"person"},
                 {  "titulo":"Clientes","id":1,"nombre":"ClientesPage","ruta":"ClientesPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"person"},
                 {  "titulo":"Proveedores","id":1,"nombre":"ProveedoresPage","ruta":"ProveedoresPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"person"},
                 {  "titulo":"Negocio","id":2,"nombre":"CompaniasPage","ruta":"CompaniasPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"stats"},
                 {  "titulo":"Negocios usuarios","id":2,"nombre":"CompaniasUsuariosPage","ruta":"CompaniasUsuariosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"stats"},
                 {  "titulo":"Permiso por página","id":2,"nombre":"PermisosPage","ruta":"PermisosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"stats"},
                 {  "titulo":"Grupos","id":3,"nombre":"GruposProductosPage","ruta":"GruposProductosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},
                 {  "titulo":"Productos","id":3,"nombre":"ProductosRapidosComponent","ruta":"ProductosRapidosComponent","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},
                //  {  "titulo":"Productos","id":3,"nombre":"ProductosPage","ruta":"ProductosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},
                //  {  "titulo":"Productos Elaborados","id":3,"nombre":"ProductosElaboradosPage","ruta":"ProductosElaboradosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},

                 {  "titulo":"Productos Elaborados Contenido","id":3,"nombre":"ProductosElaboradosContenidoPage","ruta":"ProductosElaboradosContenidoPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},
                 {  "titulo":"Productos Por Grupos Drag","id":3,"nombre":"ProductosPorGruposDragPage","ruta":"ProductosPorGruposDragPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},
                 {  "titulo":"Permiso opciones usuario","id":3,"nombre":"PermisosOpcionesUsuariosPage","ruta":"PermisosOpcionesUsuariosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},
                 {  "titulo":"Conceptos egresos - ingresos","id":4,"nombre":"ConceptosEgresosPage","ruta":"ConceptosEgresosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"card"},
                 {  "titulo":"Egresos - Ingresos","id":4,"nombre":"EgresosIngresosDiariosPage","ruta":"EgresosIngresosDiariosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"card"},
                 {  "titulo":"Cargar Stock","id":4,"nombre":"ProveedoresCargarStockPage","ruta":"ProveedoresCargarStockPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"card"},
                 {  "titulo":"Caja","id":5,"nombre":"CajaPage","ruta":"CajaPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Salón","id":5,"nombre":"MesasPage","ruta":"MesasPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Pedidos salón","id":5,"nombre":"MeseromeseroPage","ruta":"MeseromeseroPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Cuentas por cobrar","id":5,"nombre":"CuentasPorCobrarPage","ruta":"CuentasPorCobrarPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Pagar créditos","id":5,"nombre":"CuentasPorCobrarCreditosPage","ruta":"CuentasPorCobrarCreditosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Intereses créditos","id":5,"nombre":"InteresesCreditosComponent","ruta":"InteresesCreditosComponent","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Gestión comandas","id":5,"nombre":"ComandasPage","ruta":"ComandasPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Gestión salón","id":5,"nombre":"SalonPage","ruta":"SalonPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Clave pedidos salón","id":5,"nombre":"UsuarioPedidoSalonComponent","ruta":"UsuarioPedidoSalonComponent","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Reservas","id":6,"nombre":"ReservasPage","ruta":"ReservasPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Grupos reservas","id":6,"nombre":"GruposReservasPage","ruta":"GruposReservasPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Tipos reservas","id":6,"nombre":"TiposReservasPage","ruta":"TiposReservasPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Grupos reserva por productos","id":6,"nombre":"GruposReservasPorProductoPage","ruta":"GruposReservasPorProductoPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Tipos reservas por valor","id":6,"nombre":"ReservasTiposPorValorPage","ruta":"ReservasTiposPorValorPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Grupo familiar","id":6,"nombre":"ReservasGrupalesComponent","ruta":"ReservasGrupalesComponent","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Reservas sin asignar","id":6,"nombre":"ReservasSinAsignarPage","ruta":"ReservasSinAsignarPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"bookmark"},
                 {  "titulo":"Cierre caja","id":7,"nombre":"CuadreCajaDiarioValoresPorDenominacionPage","ruta":"CuadreCajaDiarioValoresPorDenominacionPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                 {  "titulo":"Perdidas","id":7,"nombre":"DesperdiciosPage","ruta":"DesperdiciosPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                 {  "titulo":"Entidades","id":7,"nombre":"EntidadesGeneralesPage","ruta":"EntidadesGeneralesPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                 {  "titulo":"Gestionar publicidad","id":7,"nombre":"CrearCarruselImagePage","ruta":"CrearCarruselImagePage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                 {  "titulo":"Publicidad","id":7,"nombre":"CarruselImagePage","ruta":"CarruselImagePage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                 {  "titulo":"Impresora","id":7,"nombre":"ImpresoraPage","ruta":"ImpresoraPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"build"},
                 {  "titulo":"Ventas diarias por costos","id":8,"nombre":"VentasDiariasPorCostosPage","ruta":"VentasDiariasPorCostosPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"analytics"},
                 {  "titulo":"Actualizar Inventario","id":8,"nombre":"inventarioPage","ruta":"inventarioPage",
                  "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"analytics"},
                  {  "titulo":"Ventas","id":8,"nombre":"GraficasPage","ruta":"GraficasPage",
                    "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"analytics"},
                  {"titulo":"Balance general","id":9,"nombre":"InformeBalanceNegocioPage","ruta":"InformeBalanceNegocioPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"stats"},
                 {"titulo":"Cantidades vendidas descontadas del stock","id":10,"nombre":"InformeCantidadesDescontadasInventarioPorDiaPage","ruta":"InformeCantidadesDescontadasInventarioPorDiaPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"globe"},
                 {"titulo":"Cantidades vendidas","id":10,"nombre":"InformeProductosVendidosPorDiasPage","ruta":"InformeProductosVendidosPorDiasPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"stats"},
                 {"titulo":"Desperdicios","id":10,"nombre":"InformeDesperdiciosPorDiaPage","ruta":"InformeDesperdiciosPorDiaPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"beer"},
                 {"titulo":"Cuadre caja","id":10,"nombre":"InformeCuadresDiariosPage","ruta":"InformeCuadresDiariosPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"albums"},
                 {"titulo":"Existencia productos","id":10,"nombre":"InformeExistenciasProductosActualesPage","ruta":"InformeExistenciasProductosActualesPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"basket"},
                 {"titulo":"Ingreso mercancia","id":10,"nombre":"InformeIngresoMercanciaPorDiaPage","ruta":"InformeIngresoMercanciaPorDiaPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"cart"},
                 {"titulo":"Cambios en maestros","id":10,"nombre":"InformeCambiosMaestroComponent","ruta":"InformeCambiosMaestroComponent",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"cart"},
                 {"titulo":"Reimprimir recibos de caja","id":8,"nombre":"InformeReimprimirReciboCajaPage","ruta":"InformeReimprimirReciboCajaPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"copy"},
                 {"titulo":"Ventas devueltas","id":8,"nombre":"InformeVentasDevueltasPage","ruta":"InformeVentasDevueltasPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"return-left"},
                 {"titulo":"Cuentas por Cobrar","id":8,"nombre":"InformeCuentasPorCobrarPage","ruta":"InformeCuentasPorCobrarPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"briefcase"},
                 {"titulo":"turnos","id":11,"nombre":"InformeGestionesPage","ruta":"InformeGestionesPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"cart"},
                 {  "titulo":"Cierre caja","id":12,"nombre":"CuadreCajaDiarioValoresPorDenominacionPage","ruta":"CuadreCajaDiarioValoresPorDenominacionPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"closed-captioning"},
                {  "titulo":"Parametros generales","id":12,"nombre":"ParametrosGeneralesPage","ruta":"ParametrosGeneralesPage",
                 "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"build"},
                {  "titulo":"Parametros Caja","id":12,"nombre":"ParametrosCajaPage","ruta":"ParametrosCajaPage",
                "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"return-left"},
                {  "titulo":"Devolver factura","id":13,"nombre":"DevolverVentasPage","ruta":"DevolverVentasPage",
                "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v 1534611819/seguridad-min_dwzsgg.jpg","icon":"arrow-back"},
                {  "titulo":"Devolver abono","id":13,"nombre":"DevolverAbonosPage","ruta":"DevolverAbonosPage",
                "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"return-left"},
                {  "titulo":"Proveedora por producto","id":14,"nombre":"ProveedoraPorProductoComponent","ruta":"ProveedoraPorProductoComponent",
                "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"albums"},
                {  "titulo":"Proveedora producto equivalencia","id":14,"nombre":"ProveedoraPorProductoEquivalenciaComponent","ruta":"ProveedoraPorProductoEquivalenciaComponent",
                "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"albums"},
                {  "titulo":"Traspaso de productos","id":14,"nombre":"ProductosTransladosComponent","ruta":"ProductosTransladosComponent",
                  "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"albums"},
                {  "titulo":"Parqueadero","id":15,"nombre":"ParqueaderosComponent","ruta":"ParqueaderosComponent",
                "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"cart"},
                {  "titulo":"Estados parqueadero","id":15,"nombre":"EstadosParqueaderoComponent","ruta":"EstadosParqueaderoComponent",
                "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"cart"},
                {  "titulo":"Estados por valor","id":15,"nombre":"EstadosParqueaderosPorValorComponent","ruta":"EstadosParqueaderosPorValorComponent",
                "imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1534611819/seguridad-min_dwzsgg.jpg","icon":"cart"},
                {  "titulo":"Factura electrónica","id":16,"nombre":"DianFacturaElectronicaPage","ruta":"DianFacturaElectronicaPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"person"},
                {  "titulo":"Pos electrónico","id":16,"nombre":"PoselectronicoPage","ruta":"PoselectronicoPage","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"person"},
                {  "titulo":"ventas","id":16,"nombre":"InformesMovimientosElectronicosComponent","ruta":"InformesMovimientosElectronicosComponent","imagen":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1511852931/caja_cs6wvs.jpg","icon":"person"},
              ]
               }else{

                 this.navCtrl.setRoot('PrincipalPage');
               }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportesPage');
  }
  abrirPaginaDesdeMenu(ruta:any,nombre:any){
    this.storages.get('rut').then((val)=>{
      this.recorrerVal = JSON.parse(val)
      let data = 0

      for(var i=0;i < this.recorrerVal.length;i++){
        if(this.recorrerVal[i].nombre == nombre){
          data = -1
        }
      }

      if(data!=-1){
        // this.mostrarMensajes('No tiene permisos para ingresar','Verifique..')
        this.utils.mensajeMuestro('Seguridad','No tiene permisos para ingresar. Verifique', 'warning')
      }else{
       this.irArutas(ruta)
       // this.menuControllers.close()
      }
    })
  }




  irArutas(ruta:any){
    switch(ruta){
      case "CargosPage":
        this.navCtrl.push(CargosPage)
      break;
      case "UsuariosPage":
        this.navCtrl.push(UsuariosPage)
      break;
      case "ClientesPage":
      this.navCtrl.push(ClientesPage)
      break;
      case "ProveedoresPage":
      this.navCtrl.push(ProveedoresPage)
      break;
      case "CompaniasPage":
      this.navCtrl.push(CompaniasPage)
      break;
      case "CompaniasUsuariosPage":
      this.navCtrl.push(CompaniasUsuariosPage)
      break;
      case "PermisosPage":
      this.navCtrl.push(PermisosPage)
      break;
      case "PermisosPage":
      this.navCtrl.push(PermisosPage)
      break;
      case "PermisosOpcionesUsuariosPage":
      this.navCtrl.push(PermisosOpcionesUsuariosPage)
      break;
      case "GruposProductosPage":
      this.navCtrl.push(GruposProductosPage)
      break;
      case "ProductosPage":
      this.navCtrl.push(ProductosPage)
      break;
      case "ProductosElaboradosPage":
      this.navCtrl.push(ProductosElaboradosPage)
      break;
      case "ProductosElaboradosContenidoPage":
      this.navCtrl.push(ProductosElaboradosContenidoPage)
      break;
      case "ProductosPorGruposDragPage":
      this.navCtrl.push(ProductosPorGruposDragPage)
      break;
      case "ConceptosEgresosPage":
      this.navCtrl.push(ConceptosEgresosPage)
      break;
      case "EgresosIngresosDiariosPage":
      this.navCtrl.push(EgresosIngresosDiariosPage)
      break;
      case "ProveedoresCargarStockPage":
      this.navCtrl.push(ProveedoresCargarStockPage)
      break;
      case "MesasPage":
      this.navCtrl.push(MesasPage)
      break;
      case "MeseromeseroPage":
      this.navCtrl.push(MeseromeseroPage)
      break;
      case "ComandasPage":
      this.navCtrl.push(ComandasPage)
      break;
      case "SalonPage":
      this.navCtrl.push(SalonPage)
      break;
      case "CajaPage":
      this.navCtrl.push(CajaPage)
      break;
      case "CuentasPorCobrarPage":
      this.navCtrl.push(CuentasPorCobrarPage)
      break;
      case "CuadreCajaDiarioValoresPorDenominacionPage":
      this.navCtrl.push(CuadreCajaDiarioValoresPorDenominacionPage)
      break;
      case "DesperdiciosPage":
      this.navCtrl.push(DesperdiciosPage)
      break;
      case "EntidadesGeneralesPage":
      this.navCtrl.push(EntidadesGeneralesPage)
      break;
      case "CrearCarruselImagePage":
      this.navCtrl.push(CrearCarruselImagePage)
      break;
      case "CarruselImagePage":
      this.navCtrl.push(CarruselImagePage)
      break;
      case "ImpresoraPage":
      this.navCtrl.push(ImpresoraPage)
      break;
      case "VentasDiariasPorCostosPage":
      this.navCtrl.push(VentasDiariasPorCostosPage)
      break;
      case "InformeBalanceNegocioPage":
      this.navCtrl.push(InformeBalanceNegocioPage)
      break;
      case "InformeCantidadesDescontadasInventarioPorDiaPage":
      this.navCtrl.push(InformeCantidadesDescontadasInventarioPorDiaPage)
      break;
      case "InformeProductosVendidosPorDiasPage":
      this.navCtrl.push(InformeProductosVendidosPorDiasPage)
      break;
      case "InformeDesperdiciosPorDiaPage":
      this.navCtrl.push(InformeDesperdiciosPorDiaPage)
      break;
      case "InformeCuadresDiariosPage":
      this.navCtrl.push(InformeCuadresDiariosPage)
      break;
      case "InformeExistenciasProductosActualesPage":
      this.navCtrl.push(InformeExistenciasProductosActualesPage)
      break;
      case "InformeIngresoMercanciaPorDiaPage":
      this.navCtrl.push(InformeIngresoMercanciaPorDiaPage)
      break;
      case "InformeReimprimirReciboCajaPage":
      this.navCtrl.push(InformeReimprimirReciboCajaPage)
      break;
      case "InformeVentasDevueltasPage":
      this.navCtrl.push(InformeVentasDevueltasPage)
      break;
      case "InformeCuentasPorCobrarPage":
      this.navCtrl.push(InformeCuentasPorCobrarPage)
      break;
      case "InformeGestionesPage":
      this.navCtrl.push(InformeGestionesPage)
      break;
      case "CuadreCajaDiarioValoresPorDenominacionPage":
      this.navCtrl.push(CuadreCajaDiarioValoresPorDenominacionPage)
      this.menuControllers.close()
      break;
      case "ParametrosGeneralesPage":
      this.navCtrl.push(ParametrosGeneralesPage)
      this.menuControllers.close()
      break;
      case "ParametrosCajaPage":
      this.navCtrl.push(ParametrosCajaPage)
      this.menuControllers.close()
      break;
      case "DevolverVentasPage":
      this.navCtrl.push(DevolverVentasPage)
      this.menuControllers.close()
      break;
      case "DevolverAbonosPage":
      this.navCtrl.push(DevolverAbonosPage)
      this.menuControllers.close()
      break;
      case "ReservasPage":
        this.navCtrl.push(ReservasPage)
        break;
      case "GruposReservasPage":
        this.navCtrl.push(GruposReservasPage)
        break;
      case "TiposReservasPage":
        this.navCtrl.push(TiposReservasPage)
        break;
      case "GruposReservasPorProductoPage":
        this.navCtrl.push(GruposReservasPorProductoPage)
        break;
      case "ReservasTiposPorValorPage":
        this.navCtrl.push(ReservasTiposPorValorPage)
        break;
      case "ReservasSinAsignarPage":
        this.navCtrl.push(ReservasSinAsignarPage)
        break;
      case "InformeCambiosMaestroComponent":
        this.navCtrl.push(InformeCambiosMaestroComponent)
        break;
      case "ProveedoraPorProductoComponent":
        this.navCtrl.push(ProveedoraPorProductoComponent)
        break;
      case "ProveedoraPorProductoEquivalenciaComponent":
        this.navCtrl.push(ProveedoraPorProductoEquivalenciaComponent)
        break;
      case "EstadosParqueaderoComponent":
        this.navCtrl.push(EstadosParqueaderoComponent)
        break;
      case "EstadosParqueaderosPorValorComponent":
        this.navCtrl.push(EstadosParqueaderosPorValorComponent)
        break;
      case "ParqueaderosComponent":
        this.navCtrl.push(ParqueaderosComponent)
        break;
      case "ReservasGrupalesComponent":
        this.navCtrl.push(ReservasGrupalesComponent)
        break;
      case "ProductosRapidosComponent":
        this.navCtrl.push(ProductosRapidosComponent)
        break;
      case "PoselectronicoPage":
        this.navCtrl.push(PoselectronicoPage)
        break;
      case "DianFacturaElectronicaPage":
        this.navCtrl.push(DianFacturaElectronicaPage)
        break;
      case "MovimientosElectronicosComponent":
        this.navCtrl.push(MovimientosElectronicosComponent)
      break;
      case "InformesMovimientosElectronicosComponent":
        this.navCtrl.push(InformesMovimientosElectronicosComponent)
        break;
      case "InteresesCreditosComponent":
        this.navCtrl.push(InteresesCreditosComponent)
      break;
      case "ProductosTransladosComponent":
        this.navCtrl.push(ProductosTransladosComponent)
      break;
      case "UsuarioPedidoSalonComponent":
        this.navCtrl.push(UsuarioPedidoSalonComponent)
      break;
      case "CuentasPorCobrarCreditosPage":
        this.navCtrl.push(CuentasPorCobrarCreditosPage)
      break;
      case "inventarioPage":
        this.navCtrl.push(inventarioPage)
      break;
      case "GraficasPage":
        this.navCtrl.push(GraficasPage)
      break;
   }
  }
  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts